export default __webpack_public_path__ + "static/media/CA-5 After create app.7fb8847c.png";